export default __webpack_public_path__ + "static/media/question-mark-in-dark-circle.b1172a01.svg";